import React, { useState } from 'react';
import { Box, Slide } from '@material-ui/core';
import { registerFromInvitationInitialStep as registerLocales } from 'globals/locales/registration';
import {
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
  FsHello,
  FsStep,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import FsRegisterFromInvitationForm from 'ui-elements/forms/FsRegisterFromInvitationForm';
import { FsRegisterFromInvitationDataForm } from 'ui-elements/forms/FsRegisterFromInvitationForm/FsRegisterFromInvitationForm';
import { RegisterFromInvitationDataProps } from '../Steps.types';

interface RegisterFromInvitationFormStepProps
  extends RegisterFromInvitationDataProps {
  onGoNext?: (props?: FsRegisterFromInvitationDataForm) => void;
}

const RegisterFromInvitationFormStep: React.FC<RegisterFromInvitationFormStepProps> = ({
  onGoNext,
  phoneNumber,
  lastName,
  firstName,
  email,
  password,
  repeatPassword,
}) => {
  const [
    formDefaults,
    setFormDefaults,
  ] = useState<FsRegisterFromInvitationDataForm>({
    firstName: firstName || '',
    lastName: lastName || '',
    email: email || 'lorem@ipsum.com',
    password: password || '',
    repeatPassword: repeatPassword || '',
    phoneNumber: phoneNumber || '+44',
  });

  const handleSuccess = (props: FsRegisterFromInvitationDataForm) => {
    setFormDefaults(props);
    if (onGoNext) onGoNext(props);
  };

  return (
    <Slide direction="left" in timeout={300}>
      <FsStep>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
        <FsCenterBoxSubTitle>{registerLocales.subTitle}</FsCenterBoxSubTitle>
        <FsCenterBoxLine />
        <Box marginTop={3}>
          <FsRegisterFromInvitationForm
            {...formDefaults}
            onSuccess={handleSuccess}
          />
        </Box>
      </FsStep>
    </Slide>
  );
};

export default RegisterFromInvitationFormStep;
